import AddIcon from "@mui/icons-material/Add"
import { Box, Tooltip } from "@mui/material"
import React, { useContext } from "react"
import { BaseButton } from "../../../../../../../components/buttons/BaseButton"
import { TabEnum } from "../../../../../../../components/tabs/tabs"
import { BSBuildingAccordion } from "./BSBuildingAccordion"
import { BSBuildingListContext } from "./context/BSBuildingListContext"

interface IProps {
  selectedTab: number
  setOpenCreateBuildingForm: React.Dispatch<React.SetStateAction<boolean>>

  handleSelectTab(index: TabEnum, buildingId?: string): void
}

export function BSBuildingList({
  selectedTab,
  handleSelectTab,
  setOpenCreateBuildingForm,
}: Readonly<IProps>): React.JSX.Element {
  const { bsBuildingList } = useContext(BSBuildingListContext)

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flex: 1,
        overflowY: "auto",
        scrollbarGutter: "stable",
        pr: "2px",
        rowGap: 1,
      }}>
      {bsBuildingList?.map((bsBuilding) => (
        <BSBuildingAccordion
          key={bsBuilding.id}
          bsBuilding={bsBuilding}
          selectedTab={selectedTab}
          handleSelectTab={handleSelectTab}
        />
      ))}

      {/* for v.0 add button is disabled when there is one building already */}
      <Tooltip arrow title={bsBuildingList.length > 0 ? "Fonctionnalité en cours de développement" : ""}>
        <Box>
          <BaseButton
            onClick={() => setOpenCreateBuildingForm(true)}
            label="Ajouter"
            icon={AddIcon}
            disabled={bsBuildingList && bsBuildingList?.length >= 1}
          />
        </Box>
      </Tooltip>
    </Box>
  )
}
